import React from "react";
import { Field } from "redux-form";

import { CustomInput } from "components";
import { FormColumn, FormRow } from "components/layout";
import { trimNormalizer } from "validators";
import { maxLength12, maxLength4 } from "validators/validation";

type FdNorthFieldsProps = {
	loading: boolean;
	name: string;
};

export const FdNorthFields = ({ loading, name }: FdNorthFieldsProps) => {
	return (
		<>
			<FormRow>
				<FormColumn>
					<Field
						label="Bank ID"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="number"
						name={`${name}.bank_id`}
						validate={maxLength12}
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						hideRequiredMark
					/>
				</FormColumn>
				<FormColumn>
					<Field
						label="Corp ID"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="number"
						name={`${name}.corp_id`}
						validate={maxLength12}
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						hideRequiredMark
					/>
				</FormColumn>
			</FormRow>
			<FormRow>
				<FormColumn>
					<Field
						label="Rep ID"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="number"
						name={`${name}.rep_id`}
						validate={maxLength4}
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						hideRequiredMark
					/>
				</FormColumn>
			</FormRow>
			<Field
				component={CustomInput}
				type="hidden"
				name={`${name}.id`}
				disabled
				wrapperClassName="d-none"
			/>
		</>
	);
};
